import { render, staticRenderFns } from "./DivulgationAgenda.vue?vue&type=template&id=d3ae75da&scoped=true&"
import script from "./DivulgationAgenda.vue?vue&type=script&lang=js&"
export * from "./DivulgationAgenda.vue?vue&type=script&lang=js&"
import style0 from "./DivulgationAgenda.vue?vue&type=style&index=0&id=d3ae75da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3ae75da",
  null
  
)

export default component.exports